import { render, staticRenderFns } from "./UnassignedWatermetersSettings.vue?vue&type=template&id=6a461ba0&"
import script from "./UnassignedWatermetersSettings.vue?vue&type=script&lang=js&"
export * from "./UnassignedWatermetersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports